import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";

import { createLegacyApiWarningAttributes, getIsEvo } from "../../utils";

import { OmpApiLegacy } from "./OmpApiLegacy/OmpApiLegacy";

import type { OmpApiContract } from "./OmpApi.types";
import { OmpApiEvo } from "./OmpApiEvo";

export class OmpApi {
  static init(): OmpApiContract {
    const config = getConfig();

    if (config.USE_EVO_ONLY) {
      return new OmpApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.OMP_URL)) {
      return new OmpApiEvo(config.OMP_URL, config.X_DES_AK_TENANT_TOKEN_CONTACT, config["X-RECAPTCHA-ID"]);
    }
    newrelic.sendWarning(
      "OmpApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.OMP_URL)
    );

    return new OmpApiLegacy(config.OMP_URL, config.X_DES_AK_TENANT_TOKEN_CONTACT);
  }
}
